interface InforMessageProps {
  message: string;
}

const InfoMessage: React.FC<InforMessageProps> = ({ message }) => {
  return (
    <div className="w-full justify-center py-6 flex text-xs text-gray-600">
      {message}
    </div>
  );
};
export default InfoMessage;
